import React from 'react';
import PropTypes from 'prop-types';

import TrackedLink from './TrackedLink';
import ExternalLinkIcon from 'react-icons/lib/fa/external-link';
import './moreAboutThisTitle.less';
import MoreAboutThisTitleEventTypes from 'data/types/MoreAboutThisTitleEventTypes';

/**
 * A View Component used to represent a direct link to NoveList for the title being viewed.
 *
 * Interaction with this component is always expected to be logged, so be sure to provide the expected props
 * to satisfy the <TrackedLink>.
 *
 * @param {*} props
 * @returns MoreAboutThisTitle component
 */
const MoreAboutThisTitle = (props) => {
	let displayText = props.cardModel.displayText ? props.cardModel.displayText : 'this title';

	let accessibilityAltText = `${displayText} in NoveList`;

	return (
		<div className="more-about-title">
			<TrackedLink featureType={MoreAboutThisTitleEventTypes.INSIDETHISBOOK_NOVELIST_CLICKED} destId={props.cardModel.destId} srcId={props.cardModel.srcId}>
				<a className="link-to-title" href={props.cardModel.href} title={accessibilityAltText} alt={accessibilityAltText} target={props.cardModel.target}>
					<ExternalLinkIcon
						className="link-to-title-img"
						title={accessibilityAltText}
						alt={accessibilityAltText}
					/>
					<span id="linkDisplayText">
						{ displayText }
					</span>
				</a>
			</TrackedLink>
			{" in NoveList" }
		</div>
	);
}

MoreAboutThisTitle.propTypes = {
	cardModel: PropTypes.object.isRequired,
};

export default MoreAboutThisTitle;



// WEBPACK FOOTER //
// ./src/react/views/generic/MoreAboutThisTitle.jsx